const theme = {
  background: '#f5f8fb',
  fontFamily: 'Poppins',
  headerBgColor: '#FBB514',
  headerFontColor: '#fff',
  headerFontSize: '18px',
  botBubbleColor: '#EEFEFD',
  botFontColor: '#6E6E6E',
  userBubbleColor: '#DDDDDD',
  userFontColor: '#100F0F',
};

export default theme;
